<template>
  <div>
    <trial-to-paid v-if='$context.is.trial2paid' :is-show-subtitle="isShowSubtitle" />
    <success :show-promotes='false' v-else-if='isZoomSchedulerFreeTrial'>
      <thanks :email='email' :title='trialTitle'>
        <subtitle :sub-title="trialSubtitle" />
        <zm-button
          v-if='isAutoAssigned'
          target='_blank'
          size='large'
          round
          type='primary'
          :href='schedulerLink'
          @click='goFreeTrialTracking'
          class='text-capitalize'>
          {{ $t('billing.trial.start_free_trial_btn', [buyTrialPlanName]) }}
        </zm-button>
        <user-management-cta :cta-name="$t('meetings.fullPlanItem30')" v-if='!isAutoAssigned' />
        <download-action v-if='$context.is.buyTrial' />
        <view-account type='round' v-if='$context.is.add2trial && isAutoAssigned' />
      </thanks>
    </success>
    <CommonAddon v-else />
  </div>
</template>

<script>
import CommonAddon from '@/views/succezz/components/common-addon.vue';
import { planTypes } from '@/common/constants';
import DownloadAction from '@/views/succezz/thanks-template/download-action.vue';
import Success from '@/views/succezz/facade.vue';
import Thanks from '@/views/succezz/thanks-template/index.vue';
import { ZOOM_SCHEDULER_ORIGIN, displayPlanNamesMap } from '@/views/success/index.vue';
import Subtitle from '@/views/succezz/thanks-template/subtitle.vue';
import common from '@/views/succezz/mixin/common';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import { mapGetters } from 'vuex';
import UserManagementCta from '@/views/succezz/thanks-template/user-management-cta.vue';
import TrialToPaid from '@/views/succezz/components/trial-to-paid.vue';

export default {
  mixins: [common],
  components: {
    TrialToPaid,
    UserManagementCta,
    ViewAccount,
    Subtitle,
    Thanks, Success, DownloadAction,
    CommonAddon,
  },
  data() {
    return {
      schedulerLink: ZOOM_SCHEDULER_ORIGIN,
    };
  },
  computed: {
    ...mapGetters(['successConfig']),
    isZoomSchedulerFreeTrial() {
      return this.$context.is.add2trial || this.$context.is.buyTrial;
    },
    buyTrialPlanName() {
      return this.$t(displayPlanNamesMap[planTypes.ZOOM_SCHEDULER]) || '';
    },
    trialTitle() {
      if (!this.isAutoAssigned) {
        return this.$t('billing.trial.trial_manually_title2');
      }
      return this.$t('billing.trial.trial_auto_assign_title', [this.buyTrialPlanName]);
    },
    isAutoAssigned() {
      return this.successConfig.userCountToAssign === 1;
    },
    trialSubtitle() {
      if (this.$context.is.buyTrial) {
        return this.$t('billing.trial.buy_trial_success', [this.buyTrialPlanName]);
      }
      if (!this.isAutoAssigned) {
        return this.$t('billing.trial.trial_manually_assign2');
      }
      return this.$t('billing.trial.trial_auto_assign_subtitle', [this.buyTrialPlanName]);
    },
    isShowSubtitle() {
      return true;
    }
  },
  methods: {
    goFreeTrialTracking() {
      this.$tracking.buyInteraction('purchase confirmation', 'set up zoom scheduler');
    },
  },
};
</script>
